import React, { useState, useEffect } from 'react';
import {
  Briefcase,
  Users,
  MapPin,
  ShieldCheck,
  Handshake,
  Building2,
  User2Icon,
} from 'lucide-react';
import AboutImg from '../Assets/images/about-page-main-image-first-brick.jpg';
import userf from "../Assets/userf.avif"

const AnimatedCounter = ({ target, label }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 2000;
    const step = Math.ceil(target / (duration / 16));

    const interval = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(interval);
      } else {
        setCount(start);
      }
    }, 16);

    return () => clearInterval(interval);
  }, [target]);

  return (
    <div className="about-page-fb-counter">
      <h3>{count}+</h3>
      <p>{label}</p>
    </div>
  );
};

const AboutUs = () => {
  return (
    <section className="about-page-fb">
      {/* Header */}
      <div className="about-page-fb-header">
        <h1>About Gap Realty India</h1>
        <p>
          Your trusted gateway to luxury real estate and smart property investments.
        </p>
      </div>

      {/* Hero Image */}
      <div className="about-page-fb-hero-image">
        <img src={AboutImg} alt="Gap Realty India Property" />
      </div>

      {/* Main Content Sections */}
      <div className="about-page-fb-main">
        <div className="about-page-fb-content">
          {/* Company Overview */}
          <div className="about-page-fb-section black-section">
            <h2>
              <Building2 size={22} /> Company Overview
            </h2>
            <p>
              Gap Realty India is a premium real estate brand committed to connecting discerning buyers and sellers with luxury, comfort, and unmatched value. With over two decades of real estate experience, we specialize in high-end residential and commercial properties across India’s most dynamic markets.
            </p>
            <p>
              Our strength lies in personalized service, deep market insights, and a transparent approach that puts your needs at the center. Whether you're an investor, a homebuyer, or a business, Gap Realty India delivers results with integrity, speed, and care.
            </p>
            <p>
              Our experienced consultants walk with you every step of the journey—from site visits to documentation, and from investment strategy to after-sales support.
            </p>
            <p>
              At Gap Realty India, we don't just deal in properties—we help you secure your future in style.
            </p>
          </div>

          <div className="about-page-fb-section black-section">
            <h2>
              <User2Icon size={22} /> Founder
            </h2>
            <div className="team-section">
              <div className="team-card">
                <div className="team-image-wrapper">
                  <img
                    src={userf}  // replace with actual image path
                    alt="Founder - Gap Realty India"
                    className="team-image"
                  />
                </div>

                <div className="team-content">
                  <h3 className="team-name">Akansha Maheshwari</h3>
                  <span className="team-designation">Founder</span>
                </div>
              </div>
            </div>

          </div>

          {/* Mission */}
          <div className="about-page-fb-section gold-section">
            <h2>
              <Handshake size={22} /> Our Mission
            </h2>
            <p>
              To redefine real estate experiences by delivering world-class service, expert guidance, and client-focused results across every transaction.
            </p>
            <p>
              Our mission is rooted in trust, transparency, and excellence—so you can make confident decisions in the ever-evolving property market.
            </p>
          </div>

          {/* Core Values */}
          <div className="about-page-fb-section black-section">
            <h2>
              <ShieldCheck size={22} /> Core Values
            </h2>
            <ul>
              <li>
                <ShieldCheck size={18} /> Integrity – Always honest, always fair.
              </li>
              <li>
                <Briefcase size={18} /> Expertise – Market mastery with innovative thinking.
              </li>
              <li>
                <Users size={18} /> Client-First – Your vision drives our every move.
              </li>
            </ul>
            <p>
              These values are the foundation of every partnership, property, and promise we deliver.
            </p>
          </div>
        </div>
      </div>

      {/* Trust Badges */}
      {/* <div className="about-page-fb-trust-badges">
        <h2 className="about-page-fb-trust-heading">
          Why Clients Trust Gap Realty India
        </h2>
        <div className="about-page-fb-badges-grid">
          <div className="about-page-fb-badge">
            <ShieldCheck size={28} />
            <p>Premium Listings</p>
          </div>
          <div className="about-page-fb-badge">
            <Handshake size={28} />
            <p>Dedicated Support</p>
          </div>
          <div className="about-page-fb-badge">
            <Users size={28} />
            <p>2,500+ Satisfied Buyers</p>
          </div>
          <div className="about-page-fb-badge">
            <Briefcase size={28} />
            <p>20+ Years Industry Presence</p>
          </div>
        </div>
      </div>

      <div className="about-page-fb-counters">
        <AnimatedCounter target={2500} label="Satisfied Buyers" />
        <AnimatedCounter target={200} label="Properties Sold" />
        <AnimatedCounter target={15} label="Cities Covered" />
      </div> */}

      {/* Founder Quote */}
      <div className="about-page-fb-founder-quote">
        <blockquote>
          <p>
            "At Gap Realty India, we don’t just sell properties—we build lasting relationships rooted in trust and performance."
          </p>
          <footer>
            <cite>- Gap Realty India Team</cite>
          </footer>
        </blockquote>
      </div>
    </section>
  );
};

export default AboutUs;
